import React from 'react';
import {
  Box,
  Container,
  Flex,
  Heading,
  IconButton,
  Img,
  Link,
  ListItem,
  Text,
  UnorderedList,
} from '@chakra-ui/react';
import { FaLinkedin } from 'react-icons/fa';

// eslint-disable-next-line arrow-body-style
const TheContextStartupBlog = () => {
  return (
    <>
      {/* members */}
      <Flex
        as="section"
        flexDirection="column"
        overflow="hidden"
        justify="center"
        height={{ xs: '450px', sm: '300px' }}
        minH={{ xs: '450px', sm: '300px' }}
        maxH="450px"
        pos="relative"
      >
        <Img
          pos="absolute"
          objectFit="cover"
          src="/jpg/blogBanner.jpg"
          alt="members-hero"
          height="100%"
          width="100%"
        />
        <Box
          bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
          pos="absolute"
          height="100%"
          width="100%"
          opacity="0.7"
        />
        <Container
          display="flex"
          as="section"
          maxW="container.xl"
          position="relative"
          zIndex="1"
          flexDirection="column"
        >
          <Flex
            alignItems={{ xs: 'flex-start', md: 'flex-start' }}
            justifyContent="center"
            columnGap="24px"
            justifyItems="center"
            width="100%"
            display="flex"
            as="section"
            rowGap="30px"
            flexDir={{
              xs: 'column',
              md: 'row',
            }}
          >
            <Flex flexDir="column" rowGap="16px">
              <Heading
                color="white"
                fontSize={{ xs: '36px', sm: '42px', lg: '64px' }}
                fontWeight="800"
                lineHeight={{ xs: '35px', lg: '83px' }}
              >
                #TheContext
              </Heading>
            </Flex>
            <Box
              w="1.5px"
              h={{ xs: '100%' }}
              bgColor="white"
              display={{ xs: 'none', md: 'block' }}
            />
            <Box
              w={{ xs: '70%', sm: '60%' }}
              h="1.5px"
              bgColor="white"
              display={{ xs: 'block', md: 'none' }}
            />
            {/*  */}
            <Heading
              as="h1"
              mb={{ xs: '10px', md: '20px' }}
              variant="reportCardTitle"
              fontSize={{ xs: '27px', sm: '29px', md: '32px', lg: '38px' }}
              color="white"
              lineHeight={{ xs: '36px', sm: '40px', md: '46px', lg: '62px' }}
            >
              Startup Journey: From Selling a Dream to Selling Reality
            </Heading>
          </Flex>
        </Container>
      </Flex>
      <Container
        as="section"
        maxW="container.xl"
        pb="80px"
        pt="40px"
        minH="420px"
        display={{ xs: 'flex', md: 'inherit' }}
        flexDirection="column"
      >
        <Box
          float={{ xs: 'right', md: 'left' }}
          alignSelf={{ xs: 'center', md: 'flex-start' }}
          mx={{ xs: '0px', md: '0px' }}
          mr={{ xs: '0px', md: '40px', lg: '60px', xl: '40px' }}
          mb="20px"
        >
          <Flex
            flexDir={{
              xs: 'column',
              md: 'row',
            }}
            gap="20px"
            alignItems={{
              xs: 'center',
              md: 'unset',
            }}
          >
            <Img
              src="https://static.levocdn.com/WGLBUT82/Screenshot2025-01-31at42828PM-w9fQJvlp8XsM.png"
              alt="Mohanjit Jolly
"
              width="250px"
              height="250px"
              objectFit="cover"
              borderRadius="50%"
            />
            <Flex direction="column">
              <Heading
                as="h1"
                fontWeight="800"
                pt="20px"
                variant="reportCardTitle"
                fontSize={{ xs: '16px', md: '18px', lg: '20px' }}
                textAlign={{
                  xs: 'center',
                  md: 'left',
                }}
              >
                Mohanjit Jolly
                <Link
                  href="https://www.linkedin.com/in/mjolly/"
                  target="_blank"
                  display={{ xs: 'inline-block', md: 'none' }}
                  pl="10px"
                >
                  <IconButton
                    aria-label="linkedin"
                    icon={<FaLinkedin size="28px" color="#067acc" />}
                    variant="unstyled"
                    cursor="pointer"
                  />
                </Link>
              </Heading>
              <Text
                color="text.mediumBlack"
                maxW={{
                  xs: '100%',
                  md: '120px',
                }}
                w="100%"
                fontSize="16px"
                lineHeight="22px"
                fontStyle="italic"
                textAlign={{
                  xs: 'center',
                  md: 'left',
                }}
              >
                Partner, Iron Pillar
              </Text>

              <Link
                href="https://www.linkedin.com/in/mjolly/"
                target="_blank"
                display={{
                  xs: 'none',
                  md: 'block',
                }}
              >
                <IconButton
                  aria-label="linkedin"
                  icon={<FaLinkedin size="28px" color="#067acc" />}
                  variant="unstyled"
                  cursor="pointer"
                />
              </Link>
            </Flex>
          </Flex>
        </Box>
        <Box>
          <Box mt="16px" mb="20px">
            <Text variant="blogAnswer">
              I have had an interesting journey over the past 25 years as a
              technology-focused startup investor. I started with a $20 million
              seed-stage fund (Garage Technology Ventures, 2002-2007),
              transitioned to primarily a Series A investor (DFJ, 2007-2015),
              and eventually moved to a growth-stage firm (Iron Pillar,
              2016-present). Throughout my career, as I transitioned from one
              firm to another, I refined my mindset and process around
              evaluating and valuing startups. While investment criteria
              typically consist of what I call the three T’s and the M—Team,
              Technology, Traction, and Market—the availability and robustness
              of data across these four metrics naturally vary over the
              lifecycle of a startup. In Silicon Valley, where I began my
              career, I often heard the saying during my Garage days: “It’s
              often easier to sell a dream than to sell reality.”
            </Text>
          </Box>
          {/* 1 */}
          <Box my="16px">
            <Text variant="blogAnswer" fontWeight="800">
              The Evolution from Dream to Reality
            </Text>
          </Box>
          <Box my="16px">
            <Text variant="blogAnswer">
              What does this mean? This phrase represents how investors at
              various stages of a company’s life cycle analyze investment
              opportunities. For instance, at the earliest stage of a
              startup—pre-product-market fit or even pre-product—the decision
              often rests on belief in the team and a potentially large market
              opportunity. There is no real data around technology/IP or
              traction at this stage. The startup is essentially selling a
              dream—what they could be. However, as the startup matures, the
              blend of dream vs. reality shifts, moving from 100% dream toward a
              more balanced reality, eventually reaching a stage where investors
              focus entirely on what the startup is and how it is performing.
              Why am I mentioning this, especially in the context of the
              upcoming IVCA Summit? Well, let me explain.
            </Text>
          </Box>
          {/* 3  */}
          <Box my="16px">
            <Text variant="blogAnswer" fontWeight="800">
              India’s Startup Landscape: A Pivotal Moment
            </Text>
            <br />
            <Box>
              <UnorderedList>
                <ListItem>
                  <Text as="span" variant="blogAnswer" py="16px">
                    A strong fundraising environment (~$16 billion raised by
                    Indian startups)
                  </Text>
                  <br />
                </ListItem>
                <ListItem>
                  <Text as="span" variant="blogAnswer" py="16px">
                    Excitement around deep tech and AI
                  </Text>
                </ListItem>
                <ListItem>
                  <Text as="span" variant="blogAnswer" py="16px">
                    The creation of new unicorns
                  </Text>
                </ListItem>
                <ListItem>
                  <Text as="span" variant="blogAnswer" py="16px">
                    Robust public markets providing much-needed exits for
                    founders, investors, and employees
                  </Text>
                </ListItem>
              </UnorderedList>
            </Box>
          </Box>
          <Text variant="blogAnswer">
            Swiggy’s IPO and Zomato’s entry into the Sensex were two standout
            moments last year. National initiatives like Startup Mahakumbh and
            TiE Global Summit, along with state-level startup programs, have
            acted as catalysts for the wave of tech entrepreneurship sweeping
            the country. The rise of domestic institutional capital, the
            maturation of domestic family offices, institutionalized wealth
            management platforms, and the increase in retail capital through
            SIPs and other mechanisms—all, combined with strong financial
            metrics of recent listings—have contributed to a buoyant public
            market. As someone who has championed the “India opportunity” for
            nearly two decades, I am thrilled to witness what seems like an
            inflection point for India. The country’s resilience and innovation
            persist despite global economic headwinds and geopolitical
            challenges. A large and growing domestic economy, combined with the
            global aspirations of budding Indian entrepreneurs and numerous
            success stories (success begets success!), is creating massive
            tailwinds for India. So much so that several companies are now
            performing reverse flip gymnastics to domicile in India, tapping
            into the buoyant domestic public markets. One of the age-old
            questions global institutional LPs have had about India concerns the
            lack of exits. Today, this concern is being vociferously answered
            through a combination of secondaries, M&A, and IPOs.
          </Text>
        </Box>
        {/* 3 */}

        <Box my="16px">
          <Text variant="blogAnswer" fontWeight="800">
            Preparing for the Public Markets: The Reality Shift
          </Text>
        </Box>
        <Box my="16px">
          <Text variant="blogAnswer">
            Returning to my dream vs. reality metaphor—when companies start
            thinking about going public (ideally, well before that), a
            significant mindset shift must occur. While early-stage or Series
            B/C investors focus on year-on-year topline growth, pre-IPO and
            cross-over investors demand tangible reality. The proxy for reality
            is <strong>profitability</strong>—preferably PAT or at least EBITDA
            profitability. The transition from being valued at multiples of
            revenue or ARR to being evaluated based on EBIT or EBITDA multiples
            is often non-trivial for founders and investors alike. But, as we
            all know (though we tend to forget at times),{' '}
            <strong>
              profitability is the only way to sustain a business long-term
            </strong>
            . <br />
            Many companies and founders in India—and especially in the U.S.—are
            still licking their wounds after the frothiness of 2021 and 2022.
            With the U.S. public markets effectively shut, many late-stage
            companies (excluding AI-driven ones) have struggled to raise
            capital. Flat and down rounds are happening behind the scenes.
            However, it is evident that if an IPO is the chosen path to
            liquidity, these companies must demonstrate reasonable (not crazy)
            growth with profitability or a clear path toward near-term
            profitability.
          </Text>
        </Box>

        <Box my="16px">
          <Text variant="blogAnswer" fontWeight="800">
            The Key Factors Defining Reality in Today’s Market
          </Text>
        </Box>
        <Box my="16px">
          <Text variant="blogAnswer">
            Indian public markets, unlike the U.S., are experiencing a surge in
            IPOs, particularly among venture-funded companies. Beyond
            profitability, here are other factors shaping the startup reality:
          </Text>
          <br />
          <Box>
            <UnorderedList>
              <ListItem>
                <Text as="span" variant="blogAnswer" py="16px">
                  <strong>Cost Discipline</strong>:Focus on positive unit
                  economics.
                </Text>
                <br />
              </ListItem>
              <ListItem>
                <Text as="span" variant="blogAnswer" py="16px">
                  <strong>Sustainable Growth</strong>: Balancing expansion with
                  profitability (30-40% profitable growth is often valued more
                  highly in public markets than 70-80% growth with a sizable
                  burn).
                </Text>
              </ListItem>
              <ListItem>
                <strong> Margin Expansion</strong>: If a startup can demonstrate
                Gross Margin and EBITDA margin expansion alongside nominal
                growth, public market investors are willing to reward them with
                forward EBITDA multiples.
              </ListItem>
            </UnorderedList>
          </Box>
          <Box my="16px">
            <Text variant="blogAnswer" fontWeight="800">
              Thinking Like a Public Company Before the IPO
            </Text>
          </Box>
          <Box my="16px">
            <Text variant="blogAnswer">
              I am not a public market investor, but my intent with this note is
              to emphasize that founders and investors—myself included—must
              start <strong>thinking like a public company</strong> well before
              the IPO milestone. This involves:
            </Text>
            <br />
            <Box>
              <UnorderedList>
                <ListItem>
                  <Text as="span" variant="blogAnswer" py="16px">
                    Strong financials
                  </Text>
                  <br />
                </ListItem>
                <ListItem>
                  <Text as="span" variant="blogAnswer" py="16px">
                    Scalable processes
                  </Text>
                </ListItem>
                <ListItem>
                  <Text as="span" variant="blogAnswer" py="16px">
                    The right team
                  </Text>
                </ListItem>
                <ListItem>
                  <Text as="span" variant="blogAnswer" py="16px">
                    Effective governance (a topic I will write about in another
                    blog! 😊)
                  </Text>
                </ListItem>
              </UnorderedList>
            </Box>
            <Box my="16px">
              <Text variant="blogAnswer" fontWeight="800">
                Looking Ahead: 2025 and Beyond
              </Text>
            </Box>
            <Box my="16px">
              <Text variant="blogAnswer">
                I am incredibly excited about what 2025 holds for the Indian
                startup ecosystem. Several venture-funded startups across SaaS,
                fintech, and D2C brands—including BlueStone and other Iron
                Pillar investee companies—are gearing up to tap the public
                markets. Remember,{' '}
                <strong>
                  exits are the flywheel for the entire Venture Capital and
                  Private Equity industry
                </strong>
                . The invest-to-harvest cycle is the foundation of the venture
                industry. India is proving to the world that its time has
                arrived—not just at the top of the funnel (startup investments)
                but also at the bottom (exits and thriving public markets)
                firing on all cylinders. As someone recently said, this is not
                just India’s decade—it’s India’s century! And the foundation for
                this rocket ship is now firmly in place.{' '}
                <strong>Upward and onward! </strong>
              </Text>
            </Box>
          </Box>
        </Box>

        <Box width="100%" height="2px" bgColor="primary.200" />
        <Text
          variant="blogAnswer"
          lineHeight="30px"
          pt="18px"
          fontStyle="italic"
          p="12px 12px 0px"
          fontWeight="500"
        >
          <Text as="span" fontWeight="700" fontStyle="normal">
            #TheContext by IVCA
          </Text>{' '}
          – features opinion makers from the alternate investing industry with
          strong focus on India as an investment destination. Watch this space
          for new announcements in the sector, viewpoints on investment themes,
          emerging trends, economic reports, analysis and latest industry
          insights.
        </Text>
        <Heading
          variant="blogQuestion"
          lineHeight="30px"
          pt="16px"
          fontStyle="italic"
          p="12px 12px 0px"
        >
          Content in this section is curated by team IVCA. To share feedback,
          connect with&nbsp;
          {/* The content in this section is curated by Team IVCA. For any feedback,
          connect with&nbsp; */}
          <Link
            href="mailto:paromita.sinha@ivca.in"
            target="_blank"
            style={{ color: 'blue', textDecoration: 'underline' }}
          >
            paromita.sinha@ivca.in
          </Link>
        </Heading>
      </Container>
    </>
  );
};

export default TheContextStartupBlog;
